import React, { Component } from 'react';

import {
  Layout,
  Toast,
  TextField,
  Thumbnail,
  Select,
  Button,
  Popover,
  Card,
  Banner,
  FormLayout,
  DropZone,
  BlockStack,
  List,
  InlineError,
  // ChoiceList, 
  // Checkbox,
  // InlineStack,
  Box,
  InlineStack,
  Page,
  SkeletonPage,
  SkeletonBodyText
  // ChoiceList,
} from '@shopify/polaris';
import utils from '../../../../../utils/utils';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import countryArrayConfig from '../../../../../assets/CountryArray';

import { ckeditorConfig, getGetSourcingListCjInfo, reqPostSourcingRequestSave,reqPostUploadImage } from '../../../../../api';

import "./index.css";
import intl from '../../../../../i18n/intl'
class LandingPageClass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ModalShow: (props.show===undefined)?false:props.show,
      loadingPage: false,
      saveLoading: false,
      addMediaLoading: false,

      productTitle: '',
      productTitleError: '',
      descValue: '',
      productUrl: '',
      productUrlError: '',
      productType: '',
      productTypeError: '',
      targetPriceError: '',
      imageError: false,
      purchasingType: 'Dropshipping',
      targetPrice: '',
      mainCountryCode: 'US',

      files: [],  // 正在上传的图片数组
      rejectedFiles: [],  // 
      successImages: [],  // 成功上传的数组(包括手动添加的图片链接)
      checked: true,
      addImageActive: false,
      addImageLink: '',
      addImageError: '',
      imageUrlErr:intl.get('Please upload a product image'),

      productTypeConfig: [
        {label: intl.get('Select'), value: '0'},
        {label: intl.get("Women's Fashion"), value: "Women's Fashion"},
        {label: intl.get("Man's Fashion"), value: "Man's Fashion"},
        {label: intl.get("Computer & Office"), value: "Computer & Office"},
        {label: intl.get("Bags & Shoes"), value: "Bags & Shoes"},
        {label: intl.get("Jewelry & Watches"), value: "Jewelry & Watches"},
        {label: intl.get("Health & Beauty, Hair"), value: "Health & Beauty, Hair"},
        {label: intl.get("Sports & Outdoors"), value: "Sports & Outdoors"},
        {label: intl.get("Home & Garden, Furniture"), value: "Home & Garden, Furniture"},
        {label: intl.get("Home improvement"), value: "Home improvement"},
        {label: intl.get("Automobiles & Motorcycles"), value: "Automobiles & Motorcycles"},
        {label: intl.get("Toys, Kids & Baby"), value: "Toys, Kids & Baby"},
        {label: intl.get("Consmuer Electronics"), value: "Consmuer Electronics"},
        {label: intl.get("Phones & Accessories"), value: "Phones & Accessories"},
        {label: intl.get("Other"), value: "Other"},
      ],
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      ModalShow: (nextProps.show===undefined)?false:nextProps.show,
      loadingPage: false,
      saveLoading: false,
      addMediaLoading: false,

      productTitle: '',
      productTitleError: '',
      descValue: '',
      productUrl: '',
      productUrlError: '',
      productType: '',
      productTypeError: '',
      targetPriceError: '',
      imageError: false,
      purchasingType: 'Dropshipping',
      targetPrice: '',
      mainCountryCode: 'US',

      files: [],  // 正在上传的图片数组
      rejectedFiles: [],  // 
      successImages: [],  // 成功上传的数组(包括手动添加的图片链接)

      addImageActive: false,
      addImageLink: '',
      addImageError: '',

    },()=>{
      if(this.props.id !== 0){
        this.initData();
      }
    });
  }

  //进入页面调用接口
  componentDidMount () {
    if(this.props.id !== 0){
      this.initData();
    }
  }

  //提示弹窗
  toggleToast = (showToastText, showToastIserror=false) => {
    this.setState(({ showToast }) => ({
      showToast: !showToast,
      showToastText: showToastText,
      showToastIserror: showToastIserror
    }));
  };

  // 初始化数据
  initData = async() => {
    this.setState({ loadingPage: true });
    const params = {
      // type: 'detail',
      id: this.props.id,
      platform:this.props.type
      // is_new:this.props.is_new
    }
    const response = await getGetSourcingListCjInfo(params)
    this.setState({ loadingPage: false });

    if(response.code==='200'){
      let getData = response.data;
      if(getData !== ''){
        this.setState({
          productTitle: getData.title,
          productUrl: getData.product_url,
          productType: getData.product_type,
          purchasingType: getData.purchasingType,
          targetPrice: getData.target_price,
          mainCountryCode: getData.main_country,
          successImages: getData.all_images.split(','),  
        },()=>{
          setTimeout(()=>{
            this.setState({descValue: getData.description,})
          },1000);
        });
      }
      
    }else{
      this.toggleToast(response.msg);
    }
  }

  // 弹窗控制
  handleChangeModal = () =>{
    this.setState({
      ModalShow:!this.state.ModalShow,
      files: [],
      rejectedFiles: [],
      successImages: []
    });
  }

  // input change
  handleInputChange = (field,value) =>{
    this.setState({
      [field]: value
    },()=>{
      if(field === 'productTitle' && value !== ''){
        if(this.state.productTitleError !== ''){
          this.setState({
            productTitleError: '',
          });
        }
      }
      if(field === 'productUrl' && value !== ''){
        if(this.state.productUrlError !== ''){
          this.setState({
            productUrlError: '',
          });
        }
      }
      if(field === 'targetPrice' && value !== ''){
        if(this.state.targetPriceError !== ''){
          this.setState({
            targetPriceError: '',
          });
        }
      }
    });
  }

  // select change
  handleSelectChange = (field,value)=> {
    this.setState({
      [field]: value
    },()=>{
      if(field === 'productType' && value !== ''){
        if(this.state.productTypeError !== ''){
          this.setState({
            productTypeError: '',
          });
        }
      }
    });
  }

  // sourcing 确认请求
  handleSourcingRequest = async () =>{
    const {
      productTitle, descValue, productUrl, productType, targetPrice, mainCountryCode, successImages,checked
    } = this.state;

    let isAllow = true;
    let productTitleError = '';
    let productUrlError = '';
    let productTypeError = '';
    let targetPriceError = '';
    let isEmptyImage = false;
    if(productTitle === ''){
      productTitleError = intl.get('Please enter a product title');
      isAllow = false;
    }

    if(productUrl !== ''){
      var re = /(http|ftp|https):\/\/[\w\-_]+(.[\w\-_]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?/;
      if(re.test(productUrl) === false){
        productUrlError = intl.get('URL is invalid');
        isAllow = false;
      }
      // if(productUrl.length >= 500){
      //   productUrlError = intl.get('The link must be between 1 and 500 characters');
      //   isAllow = false;
      // }
    }else{
      productUrlError = intl.get('Please enter a product URL');
      isAllow = false;
    }

    if(productType === ''){
      productTypeError = intl.get('Please select a product type');
      isAllow = false;
    }
    if(targetPrice === ''  || targetPrice === 0 || targetPrice === '0'){
      targetPriceError = intl.get('Please enter a valid target price');
      isAllow = false;
    }
    if (successImages.length === 0) {
      isAllow = false;
      isEmptyImage = true;
    }

    this.setState({
      productTitleError: productTitleError,
      productUrlError: productUrlError,
      productTypeError: productTypeError,
      targetPriceError: targetPriceError,
      imageError: isEmptyImage
    });

    if(!isAllow){
      return false;
    }

    this.setState({saveLoading: true});
    const params = {
      title: productTitle,
      description: descValue,
      link: productUrl.slice(0,498),
      product_type: productType,
      // purchasingType: purchasingType,
      price: targetPrice,
      main_country: mainCountryCode,
      is_public: checked ? 1 : 0,
      images: successImages.join(',')
    }

    const response = await reqPostSourcingRequestSave(params)
    this.setState({
      saveLoading: false,
    });
    if(response.code==='200'){
      // 更新父组件页面
      this.toggleToast('Request successfully', false);
      this.props.updateCallBackFun();

      this.setState({
        productTitle: '',
        descValue: '',
        productUrl: '',
        productType: '',
        purchasingType: 'Dropshipping',
        targetPrice: '',
        mainCountryCode: 'US',
        successImages: [],
      },()=>{
        // 关闭弹窗
        this.handleChangeModal();
      });
    }else{
      this.toggleToast(response.msg);
    }
  }

  // 图片上传处理
  handleDrop = (droppedFiles, acceptedFiles, rejectedFiles) =>{
    // 正在上传图片时
    const res = utils.sizeFilter(acceptedFiles[0].size)
    if (res > 5) {
      this.setState(({
        imageError: true,
        imageUrlErr:intl.get('The image size should not exceed 5M, and must a JPG or PNG')
      }))
      return false
    }
    if(this.state.files.length > 0){
      this.toggleToast("Image is uploading", false);
      return;
    }
    if(acceptedFiles[0].name.indexOf('.gif') !== -1){
      // this.toggleToast("Do not allow uploading gif images", true);
      this.setState({
        imageError:true,
        imageUrlErr:intl.get('Do not allow uploading gif images')
      });
      return;
    }
    this.setState({
      files: [...this.state.files, ...acceptedFiles],
      rejectedFiles: rejectedFiles
    },()=>{
      // 上传图片
      if(acceptedFiles.length > 0){
        var imageData = [];
        for(var i = 0; i < acceptedFiles.length; i++){
          const filesImg = acceptedFiles[i];
          // 开启FileReader
          var reader  = new FileReader();
          reader.readAsDataURL(filesImg); // 读取文件保存在result中
          reader.onload = (e) =>  {
            var getRes = e.target.result; // 读取的结果在result中
            imageData.push(
              {
                'name' : filesImg.name,
                'image' : getRes,
                'type' : filesImg.type,
              }
            );
          }
        }

        // 延时请求，预防拿不到图片数据
        setTimeout(()=>{
          this.uploadImages(imageData);
        },2000);
      }
    })
  }

  // 图片上传
  uploadImages = async(imageData)=>{
    const params = {
      data: imageData,
    }

    const response = await reqPostUploadImage(params)
    if(response.code === '200'){
      let successArr = this.state.successImages;
      let getData = response.data;
      if(getData.length > 0){
        for (let index = 0; index < getData.length; index++) {
          successArr.push(getData[index]);
        }
        this.setState({
          successImages: successArr,
          files: [],
          rejectedFiles: [],
          imageError: false
        })
      }
      // this.toggleToast(response.msg, false);
    }else{
      // this.toggleToast(response.msg);
      this.setState({
        files: [],
        rejectedFiles: [],
        imageError:true,
        imageUrlErr:response.msg
      });
    }
  }

  // 移除图片链接
  removeImage = (recordKey) =>{
    let data = this.state.successImages;
    data.splice(recordKey, 1);
    this.setState({
      successImages: data
    });
  }

   // 添加图片链接弹窗
   togglePopoverActive = () =>{
    this.setState({
      addImageActive: !this.state.addImageActive,
      addImageError: '',
    });
  }

  // 检测图片的有效性
checkImgExists = (imgurl) => {
  return new Promise(function(resolve, reject) {
    var ImgObj = new Image();
    ImgObj.src = imgurl;
    ImgObj.onload = function(res) {
      resolve(res);
    }
    ImgObj.onerror = function(err) {
      reject(err)
    }
  })
}
  // 手动添加图片链接
  handAddImageLink = () =>{
    let imageUrl = this.state.addImageLink;
    if(imageUrl !== ''){
      this.setState({addMediaLoading: true});

      // 检测图片的有效性
      if(imageUrl.indexOf('http') === -1){
        this.setState({
          addImageError: intl.get('Image URL is invalid'),
          addMediaLoading: false
        });
        return;
      }
      if(imageUrl.indexOf('.gif') !== -1){
        this.setState({
          addImageError: intl.get('Image URL is invalid'),
          addMediaLoading: false
        });
        return;
      }
      // if (!/\.(gif|jpg|jpeg|png|GIF|JPG|JPEG|PNG)$/.test(imageUrl)) {
      //   this.setState({
      //     addImageError: 'Image URL is invalid',
      //     addMediaLoading: false
      //   });
      //   return;
      // }

      try {
        this.checkImgExists(imageUrl).then(()=>{
          let data = this.state.successImages;
          data.push(imageUrl);

          this.setState({
            successImages: data,
            addMediaLoading: false,
            addImageLink: '',
            addImageError: '',
            imageError: false
          });
          this.togglePopoverActive();

        }).catch(()=>{
          this.setState({
            addImageError: intl.get('Image URL is invalid'),
            addMediaLoading: false
          })
        })
        
      } catch (error) {
        this.setState({
          addImageError: intl.get('Image URL is invalid'),
          addMediaLoading: false
        })
      }
      
    }
  }

  // 产品详情编辑
  editorContentChange = (data)=>{
    this.setState({ 
      descValue: data
    });
  };

  handleChangeCheck = (value) => {
    this.setState({
      checked: value
    })
  };
render() {
  const toastMarkup = this.state.showToast ? <Toast content={this.state.showToastText} onDismiss={()=>this.toggleToast('')} error={this.state.showToastIserror} /> : null;
  const {
      state: { 
        saveLoading,files,rejectedFiles,successImages,descValue,productTypeConfig,addImageActive,addImageError,addImageLink,imageError,
        productTitle,productTitleError,productUrl,productType,productTypeError,targetPrice,targetPriceError,mainCountryCode,addMediaLoading,productUrlError,
        // checked
        imageUrlErr
      },
  } = this;
  

  const hasError = rejectedFiles.length > 0;
  const fileUpload = !files.length && <DropZone.FileUpload actionTitle="Add image" />;

  const uploadedFiles = files.length > 0 && (
    <InlineStack>
      {files.map((file, index) => (
        <Box alignment="center" key={index}>
          <div style={{position:'relative'}}>
            <Thumbnail
              alt={file.name}
              source={window.URL.createObjectURL(file)}
            />
            {/* <div>
              {file.name} <Caption>{file.size} bytes</Caption>
            </div> */}
            <div className="Product__Loading">
              <div className="Sourcing_Request__Loading_Image">
                <img style={{width:'25px',height:'25px',verticalAlign:'middle'}} src='/loading.gif' alt="loading" />
              </div>
            </div>
          </div>
        </Box>
      ))}
    </InlineStack>
  );

  const successImagesFiles = successImages.length > 0 && (
    <div className="media_box">
      <InlineStack>
        {successImages.map((it,kk) => (
          <div className="Sourcing_Image_Item" style={{position:'relative',margin:'5px 8px 0 0'}} key={kk}>
            <Thumbnail
              alt="product image"
              source={it}
            />

            <div className="Sourcing__Loading" style={{display:this.props.isDetail?'none':'block'}}>
              <div className="Sourcing_Request__Image">
                <div className="image_remove__button" onClick={this.props.isDetail?()=>{}:()=>this.removeImage(kk)}>
                  <svg fillRule="evenodd" viewBox="0 0 20 20" focusable="false" aria-hidden="true"><path d="M17 4h-3V2c0-1.103-.897-2-2-2H8C6.897 0 6 .897 6 2v2H3a1 1 0 100 2v13a1 1 0 001 1h12a1 1 0 001-1V6a1 1 0 100-2zM8 4h4V2H8v2zm0 12a1 1 0 001-1V9a1 1 0 10-2 0v6a1 1 0 001 1zm4 0a1 1 0 001-1V9a1 1 0 10-2 0v6a1 1 0 001 1z"></path></svg>
                </div>
              </div>
            </div>
          </div>
        ))}
      </InlineStack>
    </div>
  );

  const errorMessage = hasError && (
    <Banner
      title={intl.get("The following images couldn’t be uploaded:")}
      tone="warning"
    >
      <List type="bullet">
        {rejectedFiles.map((file, index) => (
          <List.Item key={index}>
            {intl.get(`{{file}} is not supported. File type must be .jpg, .jpeg, .png.`,file.name)}
          </List.Item>
        ))}
      </List>
    </Banner>
  );

  const ModalContent = (
    <section style={{minHeight:"420px",padding:'0 16px'}}>
      <Banner tone="info" title={intl.get("After sending a sourcing request, Dropshipman will search for products based on your requirements.")}></Banner>
      <div className="space"></div>
      <div style={{maxHeight:'500px',overflowX:'hidden',overflowY:'auto'}}>
      <Layout>
        <Layout.Section>
          <FormLayout>
            <TextField 
              label={intl.get("Product Title")} 
              onChange={this.handleInputChange.bind(this,'productTitle')} 
              value={productTitle}
              placeholder={intl.get('')}
              error={productTitleError}
              maxLength={255}
              showCharacterCount
              readOnly={this.props.isDetail}
            />
            <div className='sourcing_modal_list'>
            <div className='sourcing_modal_item'>
            <TextField 
              label={intl.get("Product URL")}
              onChange={this.handleInputChange.bind(this,'productUrl')} 
              value={productUrl}
              placeholder='https://...'
              error={productUrlError}
              readOnly={this.props.isDetail}
            />
            </div>
            <div className='sourcing_modal_item'>
            <Select
              label={intl.get("Product type")}
              options={productTypeConfig}
              onChange={this.handleSelectChange.bind(this,'productType')}
              value={productType}
              error={productTypeError}
              disabled={this.props.isDetail}
            />
            </div>
            <div className='sourcing_modal_item'>
            <TextField 
              label={intl.get("Target price (Shipping fee included, USD only)")}
              onChange={this.handleInputChange.bind(this,'targetPrice')} 
              value={String(targetPrice)}
              placeholder='10.00'
              type={'number'}
              prefix={'$'}
              error={targetPriceError}
              readOnly={this.props.isDetail}
            />
            </div>
            <div className='sourcing_modal_item'>
            <Select
              label={intl.get("Destination Country")}
              options={countryArrayConfig}
              onChange={this.handleSelectChange.bind(this,'mainCountryCode')}
              value={mainCountryCode}
              disabled={this.props.isDetail}
            />
            </div>
            </div>
            <div>
              
              <div style={{fontSize:'14px',lineHeight:'20px',marginBottom:'4px'}}>
                <BlockStack>
                  <BlockStack>
                    <div>{intl.get("Media")}</div>
                  </BlockStack>
                  {!this.props.isDetail && (
                    <BlockStack>
                      <Popover
                        active={addImageActive}
                        preferredAlignment="left"
                        activator={
                          <div className="">
                            <Button 
                              variant='plain' 
                              disclosure 
                              textAlign="left"
                              onClick={this.togglePopoverActive}
                              disabled={this.props.isDetail}
                            >
                              {intl.get("Add media from URL")}
                            </Button>
                          </div>
                        }
                        onClose={this.togglePopoverActive}
                      >
                        <Card 
                        >
                          <TextField 
                            label={intl.get("Paste image URL")}
                            onChange={this.handleInputChange.bind(this,'addImageLink')} 
                            value={addImageLink}
                            placeholder='https://'
                            error={addImageError}
                          />
                          
                          <Box style={{display:'flex',justifyContent:"space-between",marginTop:'8px'}}>
                            <Button onClick={this.togglePopoverActive}>
                              {intl.get('Close')}
                            </Button>
                            <Button variant='primary' onClick={this.handAddImageLink} loading={addMediaLoading} disabled={addImageLink? false : true}>{intl.get('Add media')}</Button>
                          </Box>
                        </Card>
                      </Popover>
                    </BlockStack>
                  )}
                </BlockStack>
              </div>
              
              {errorMessage}
              {!this.props.isDetail && (
                <div>
                  <DropZone 
                    accept="image/*" 
                    type="image" 
                    onDrop={this.handleDrop}
                    disabled={this.props.isDetail}
                  >
                    {uploadedFiles}
                    {fileUpload}
                  </DropZone>
                  <div style={{marginTop: '4px', display: imageError ? 'block' : 'none'}}>
                    <InlineError message={imageUrlErr} fieldID="myFieldID" />
                  </div>
                </div>
              )}
              
              {/* 上传成功的图片列表 */}
              {successImagesFiles}

            </div>

            <div className="sourcing_product_description">
              <div style={{fontSize:'14px',lineHeight:'20px',marginBottom:'4px'}}>{intl.get("Description")}</div>
              <CKEditor
                editor={ ClassicEditor }
                config={ ckeditorConfig }
                data={descValue}
                disabled={this.props.isDetail}
                onInit={ editor => {
                //   editor.plugins.get( 'FileRepository' ).createUploadAdapter = function( loader ) {
                //    return new UploadAdapter( loader );
                //   };
                } }
                onChange={ ( event, editor ) => {
                  const data = editor.getData();
                  this.editorContentChange(data);
                } }
                onBlur={ editor => {
                  // console.log( 'Blur.', editor );
                  // this.handleContentChange();
                } }
                onFocus={ editor => {
                  // console.log( 'Focus.', editor );
                } }
              />
            </div>
          
            
          </FormLayout>
        </Layout.Section>
      </Layout>
      </div>
      <div className="agreement_accept_sourcing">
        <div style={{width:"80%"}}  >
          {/* <Checkbox
              label={intl.get('Show sourcing in Sourcing Square.')}
              checked={checked}
              onChange={this.handleChangeCheck}
          /> */}

        </div>

        <div  className="agreement_accept_button" >
          {!this.props.isDetail &&  <Button variant='primary'  onClick={this.handleSourcingRequest} loading={saveLoading}>{intl.get('Request')}</Button>}
        </div>

      </div>
    </section>
  );

  const initSkeletonPage = (
    <div>
      <SkeletonPage fullWidth={false}>
      <Layout>
            <Layout.Section>
            <Card>
            <BlockStack gap={400}>
            <SkeletonBodyText lines={3}/>
            <SkeletonBodyText lines={3}/>
            <SkeletonBodyText lines={3}/>
            <SkeletonBodyText lines={3}/>
            <SkeletonBodyText lines={3}/>
            <SkeletonBodyText lines={3}/>
            <SkeletonBodyText lines={3}/>
            <SkeletonBodyText lines={3}/>
            <SkeletonBodyText lines={3}/>
            <SkeletonBodyText lines={3}/>
            </BlockStack>
            </Card>
          </Layout.Section>
            </Layout>
      </SkeletonPage>
    </div>
  );
  return (
    <div>
    {this.state.loadingPage ? initSkeletonPage  : <Page
      title={<div style={{fontSize:'20px'}} >{intl.get("Sourcing Request")}</div>}
      backAction={{content: 'Sourcing Request', onAction: () =>{this.props.requestCreateCallBack()}}}
      fullWidth={false}
    >
      <Card>
       {
        ModalContent
       }
       </Card>
       {toastMarkup}
    </Page>}
    </div>
  );
}
}

export default LandingPageClass;